import { DEVTOOLS_MESSAGE_IDENTIFIER } from './sharedConstants';
export const KEEP_ALIVE_EVENT = 'keep-alive';
export const keepAliveEvent = () => ({
  type: KEEP_ALIVE_EVENT
});
export const STATE_CHANGE_EVENT = 'state-change';
export const stateChangeEvent = (typeName, instanceKey) => ({
  type: STATE_CHANGE_EVENT,
  typeName,
  instanceKey
});
export const INVALIDATE_EVENT = 'invalidate';
export const invalidateEvent = (typeName, instanceKey) => ({
  type: INVALIDATE_EVENT,
  typeName,
  instanceKey
});
export const REGISTER_EVENT = 'register';
export const registerEvent = (typeName, resolverName) => ({
  type: REGISTER_EVENT,
  typeName,
  resolverName
});
export const ATTACHMENT_CHANGE_EVENT = 'attachment-change';
export const attachmentChangeEvent = (instanceKey, attached) => ({
  type: ATTACHMENT_CHANGE_EVENT,
  instanceKey,
  attached
});

// The messages the devtools client can send

// The message that actually gets posted

export const isEMSDevtoolsMessage = message => {
  return message.kind === DEVTOOLS_MESSAGE_IDENTIFIER && message.type;
};
export const serializeCacheEntry = entry => {
  var _entry$state$error;
  return Object.assign({}, entry, {
    state: Object.assign({}, entry.state, {
      error: ((_entry$state$error = entry.state.error) === null || _entry$state$error === void 0 ? void 0 : _entry$state$error.message) || null
    })
  });
};
export const deserializeState = state => Object.assign({}, state, {
  error: state.error ? new Error(state.error) : null
});